var _desc, _rect, _circle, _circle2, _rect2, _path, _circle3, _circle4, _circle5, _circle6, _path2, _rect3, _rect4, _rect5, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogSalesforceCrm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Salesforce CRM customer pipeline illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Customer records moving through a CRM pipeline.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#061427"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 130,
    r: 180,
    fill: "#2563eb",
    opacity: 0.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 575,
    r: 210,
    fill: "#14b8a6",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 120,
    width: 990,
    height: 460,
    rx: 36,
    fill: "#0f172a",
    stroke: "#1d4ed8",
    strokeOpacity: 0.35,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 255h780",
    stroke: "#38bdf8",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 255,
    r: 58,
    fill: "#0ea5e9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 255,
    r: 58,
    fill: "#14b8a6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 255,
    r: 58,
    fill: "#60a5fa"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 990,
    cy: 255,
    r: 58,
    fill: "#22d3ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258 252c10-24 43-24 54 0m-70 45c20-34 66-34 86 0M493 252c10-24 43-24 54 0m-70 45c20-34 66-34 86 0M728 252c10-24 43-24 54 0m-70 45c20-34 66-34 86 0M963 252c10-24 43-24 54 0m-70 45c20-34 66-34 86 0",
    fill: "none",
    stroke: "#ecfeff",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 390,
    width: 235,
    height: 92,
    rx: 18,
    fill: "#132f45"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 390,
    width: 235,
    height: 92,
    rx: 18,
    fill: "#132f45"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 759,
    y: 390,
    width: 235,
    height: 92,
    rx: 18,
    fill: "#132f45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245 425h150M245 452h95M522 425h150M522 452h95M799 425h150M799 452h95",
    stroke: "#cbd5e1",
    strokeWidth: 13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSalesforceCrm);
export default __webpack_public_path__ + "static/media/blog-salesforce-crm.61dec2e6f03548ccbd24d5d3a60eb3a3.svg";
export { ForwardRef as ReactComponent };